
import { createTheme, styled } from "@mui/material";
import MuiAppBar from '@mui/material/AppBar';
import { red } from "@mui/material/colors";

import { envVariables } from '../helpers/getEnvVariables';
const drawerWidth = Number(envVariables.REACT_APP_TAMANIO_DRAWER);
const header = Number(envVariables.HEADER);




export const yellowTheme = createTheme({

    palette: {
        primary: {
            main: '#ff9800',
            dark: '#e68900'
        },
        secondary: {
            main: '#ed3237'
        },
        error: {
            main: red.A400
        }
    },

    components: {
        MuiTypography: {
            styleOverrides: {
                h1: {
                    fontSize: 25,
                    fontWeight: "bold",  
                    fontFamily: 'arial',
                    color: 'black'               
                },
                h2: {
                    fontSize: 18,
                    fontWeight: 'bold',
                    fontFamily: 'arial',
                },
                h3: {
                    fontSize: 15,
                    fontWeight: 'bold',
                    fontFamily: 'arial',
                },
                h4: {
                    fontSize: 22,
                    fontWeight: 'bold',
                    fontFamily: 'arial',
                },
                h5: {
                    fontSize: 16,
                    fontFamily: 'arial',
                    color: 'white',
                },

                subtitle1: {
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: 'red',
                    letterSpacing: '-1px',
                    lineHeight: 1.2
                },
                
                body2: {
                    fontSize: 15,
                    fontFamily: 'arial'
                },
            }
        },

        MuiDrawer: {
            styleOverrides: {
                paper: {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    backgroundColor: '#262626',
                },
            }
        },

        MuiTableRow: {
            styleOverrides: {
                root: {
                    "&:nth-of-type(odd)":{
                        backgroundColor: '#f5f5f5'
                    },
                    '&:last-child th': {
                        backgroundColor: '#d50000',
                        fontSize: '15px',
                        fontWeight: 'bold',
                        color: '#fff',
                        padding: '10px',
                    }
                }
            }
        },

        MuiTableCell: {
            styleOverrides: {
                root: {
                    color: '#0000000',
                    fontSize: '12px',
                    padding: '5px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    backgroundColor: "transparent",
                }
            }
        },
    }
})



// export const Main = styled('main', {
//     shouldForwardProp: (prop) => prop !== 'open',
//   })(({ theme, open }) => ({
//     flexGrow: 1,
//     padding: theme.spacing(3),
//     transition: theme.transitions.create('margin', {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     marginLeft: 0,
//     backgroundColor: '#ADADAD',
//     minHeight:'100vh',
//     ...(open && {
//       transition: theme.transitions.create('margin', {
//         easing: theme.transitions.easing.easeOut,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//       marginLeft: `${drawerWidth}px`,
//     }),
//   }));




export const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
    })(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        height: `${header}rem`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    height: "4rem",
}));




export const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: 0,
        backgroundColor: 'white',
        marginTop: `${header}rem`, 
        minHeight: `calc(100vh - ${header}rem)`,
        height: `calc(100vh - ${header}rem)`, 
        overflowX: 'hidden',
        overflowY: 'auto',
    ...(open && {
            transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: `${drawerWidth}px`,
    }),
}));



// export const AppBar = styled(MuiAppBar, {
//     shouldForwardProp: (prop) => prop !== 'open',
//     })(({ theme, open }) => ({
//     transition: theme.transitions.create(['margin', 'width'], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen,
//     }),
//     ...(open && {
//         width: `calc(100% - ${drawerWidth}px)`,
//         height: `${header}rem`,
//         marginLeft: `${drawerWidth}px`,
//         transition: theme.transitions.create(['margin', 'width'], {
//         easing: theme.transitions.easing.easeOut,
//         duration: theme.transitions.duration.enteringScreen,
//         }),
//     }),
// }));



export const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));




export const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});